import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { DialogContent as MuiDialogContent } from '@mui/material';
import { Typography } from 'src/components/atoms';

interface ContentProps {
  children: ReactNode;
}

const StyledDialogContent = styled(MuiDialogContent)(
  ({ theme }) => `
  &::-webkit-scrollbar {
    width: 0.6rem;
    border-radius: 100vw;

  }

  &::-webkit-scrollbar-thumb {
    border-radius: 100vw;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.palette.secondary.main};
  }
`
);

export const DialogContent = ({ children }: ContentProps) => {
  return (
    <StyledDialogContent>
      {typeof children === 'object' ? { ...children } : <Typography>{children}</Typography>}
    </StyledDialogContent>
  );
};
